import { Language, RegionType } from "graphql/generated";
import { checkCountry } from "src/utils/checkCountry";

export const COUNTRY_CODES = {
  HK: "hk",
  SG: "sg",
  JP: "jp"
};

const COUNTRIES = {
  [RegionType.Sg]: "Singapore",
  [RegionType.Hk]: "Hong Kong",
  [RegionType.Jp]: "Japan"
};

export const CURRENT_COUNTRY: string = process.env.NEXT_PUBLIC_COUNTRY || RegionType.Sg;

export const DEFAULT_LANG_BY_COUNTRY = {
  [RegionType.Sg]: Language.En,
  [RegionType.Hk]: Language.En,
  [RegionType.Jp]: Language.Ja
};

export const CURRENT_DEFAULT_LANG = DEFAULT_LANG_BY_COUNTRY[CURRENT_COUNTRY];

export default COUNTRIES;

export const COUNTRY_POSTAL_CODE_SYMBAL = {
  [RegionType.Sg]: "Singapore",
  [RegionType.Hk]: "Hong Kong",
  [RegionType.Jp]: "〒"
};
export const CURRENT_POSTAL_CODE: string = COUNTRY_POSTAL_CODE_SYMBAL[CURRENT_COUNTRY];
export const HAS_ZOEY_COUNTRY = checkCountry([RegionType.Hk, RegionType.Sg, RegionType.Jp]);
